import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export interface FactureInfo {
  id?: number;
  raison_sociale?: string;
  adresse?: string;
  code_postal?: string;
  ville?: string;
  rcs?: string;
  tv_intra?: string;
  created_at?: string;
  updated_at?: string;
    active?: boolean;
}

export const getFactures = async (): Promise<FactureInfo> => {
  try {
    const response = await axios.get(`${API_URL}/facture-info/get-info`);
    return response.data; // objet unique
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Erreur :", error.message);
      throw new Error(error.response?.data?.message || "Erreur lors de la récupération des infos facture.");
    }
    throw new Error("Erreur inattendue.");
  }
};


export const upsertFacture = async (facture: FactureInfo): Promise<FactureInfo> => {
  try {
    const response = await axios.post(`${API_URL}/facture-info/insert-data`, facture);
    return response.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      console.error("Erreur :", error.message);
      throw new Error(error.response?.data?.message || "Erreur lors de la création ou mise à jour de la facture.");
    }
    throw new Error("Erreur inattendue.");
  }
};
